var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 19 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3002 0H5.69982C2.55694 0 0 2.55706 0 5.70009V13.2999C0 16.4429 2.55694 19 5.69982 19H13.2993C16.4422 19 18.9991 16.4429 18.9991 13.2999L19 5.70009C19 2.55706 16.4431 0 13.3002 0ZM12.3499 12.3505H6.6501C6.12553 12.3505 5.69982 11.9248 5.69982 11.4002C5.69982 10.8756 6.12553 10.4499 6.6501 10.4499H12.3499C12.8754 10.4499 13.3002 10.8756 13.3002 11.4002C13.3002 11.9248 12.8754 12.3505 12.3499 12.3505ZM13.3002 8.55014H5.69982C5.17526 8.55014 4.74955 8.12441 4.74955 7.59982C4.74955 7.07523 5.17526 6.6495 5.69982 6.6495H13.2993C13.8247 6.6495 14.2496 7.07523 14.2496 7.59982C14.2496 8.1253 13.8248 8.55014 13.3002 8.55014Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon);
export default __webpack_public_path__ + "static/media/AboutIcon.cabf1896189aa373289af718e10bc184.svg";
export { ForwardRef as ReactComponent };